var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"click-effects-container"},_vm._l((_vm.effects),function(effect){return _c('div',{key:effect.id,staticClass:"click-effect",style:({
      left: effect.x + 'px',
      top: effect.y + 'px',
      color: effect.color,
      fontSize: effect.fontSize + 'px',
      opacity: effect.opacity,
      transform: `translate(-50%, -50%) scale(${effect.scale})`
    })},[_vm._v(" "+_vm._s(effect.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }